<div class="main-wrapper" [ngClass]="{'customopen': isSidebarOpen,'check': isHovered}">
     <app-sidebar [isSidebarOpenClosed]="isSidebarOpen"></app-sidebar> 
   <div class="main-dashboard">
        <app-header></app-header>  

<div [ngClass]="{'superadmin': role === 'SuperAdmin'}" class="dashboard-wrapper" #dashboardWrapper>

         <router-outlet (activate)="onActivate($event)"></router-outlet>

</div>
   </div>
</div>
